define('lib/view_helpers/pricingTierPlans',['require','lib/view_helpers/planPricingHelper','translate'],function (require) {
  
  var planPricingHelper = require('lib/view_helpers/planPricingHelper');

  var t = require('translate');

  var tierPrices = planPricingHelper.getPricingData();

  return {
    free: {
      name: 'free',
      order: 1,
      humanized_name: 'Free',
      price: 0,
      list_price: 0,
      enables: t('Simple work processes for small teams #pricing.tier'),
      access_rights: [
        t('Private workspaces #pricing.tier')
      ],
      features: {
        'workflows': t('Limited #pricing.tier'),
        'personal_account_manager': false,
        'personalized_training_bonus': []
      },
      reporting: t('Calculations #pricing.tier')
    },

    trial: {
      name: 'trial',
      order: 1,
      humanized_name: 'Trial',
      price: 0,
      list_price: 0,
      enables: t('Simple work processes for small teams #pricing.tier'),
      access_rights: [
        t('Private workspaces #pricing.tier')
      ],
      features: {
        'workflows': t('Limited #pricing.tier'),
        'personal_account_manager': false,
        'personalized_training_bonus': []
      },
      reporting: t('Calculations #pricing.tier')
    },

    basic: {
      name: 'basic',
      order: 2,
      humanized_name: 'Basic',
      price: tierPrices ? tierPrices['basic']['employee']['price'] : 9,
      list_price: tierPrices ? tierPrices['basic']['employee']['list_price'] : 9,
      enables: t('Simple work processes for as many people as you need #pricing.tier'),
      access_rights: [
        t('Private workspaces #pricing.tier'),
        t('User management #pricing.tier')
      ],
      features: {
        'workflows': t('Limited #pricing.tier'),
        'personal_account_manager': false,
        'personalized_training_bonus': []
      },
      reporting: t('Calculations #pricing.tier')
    },
    plus: {
      name: 'plus',
      order: 3,
      humanized_name: 'Plus',
      price: tierPrices ? tierPrices['plus']['employee']['price'] : 14,
      list_price: tierPrices ? tierPrices['plus']['employee']['list_price'] : 14,
      enables: t('Advanced project processes and workflows #pricing.tier'),
      access_rights: [
        t('Private workspaces #pricing.tier'),
        t('User management #pricing.tier'),
        t('Light user role #pricing.tier'),
        t('Read-only access #pricing.tier')
      ],
      features: {
        'workflows': t('Full #pricing.tier'),
        'personal_account_manager': true,
        'personalized_training_bonus': [
          t('Get started #pricing.tier')
        ]
      },
      isFeatured: true,
      reporting: t('Calculations #pricing.tier')
    },
    premium: {
      name: 'premium',
      order: 4,
      humanized_name: 'Premium',
      price: tierPrices ? tierPrices['premium']['employee']['price'] : 24,
      list_price: tierPrices ? tierPrices['premium']['employee']['list_price'] : 24,
      enables: t('Advanced project processes with workflows and priority support #pricing.tier'),
      access_rights: [
        t('Private workspaces #pricing.tier'),
        t('User management #pricing.tier'),
        t('Light user role #pricing.tier'),
        t('Read-only access #pricing.tier')
      ],
      features: {
        'workflows': t('Full #pricing.tier'),
        'personal_account_manager': true,
        'personalized_training_bonus': [
          t('Get started #pricing.tier'),
          t('Advanced setup #pricing.tier'),
          t('Verification session #pricing.tier')
        ]
      },
      reporting: t('Calculations and report visualisation #pricing.tier')
    },
    enterprise: {
      name: 'enterprise',
      order: 5,
      humanized_name: 'Enterprise',
      price: null,
      list_price: null,
      enables: t('Tailored solutions for large corporations #pricing.tier'),
      access_rights: [],
      features: {
        'workflows': '',
        'personalized_training_bonus': []
      },
      reporting: ''
    },
  };
});

